<sirius-slider
    #thumbnailSlider
    (selectedIndex)="setIndex($event)"
    (scrollNextEvent)="scrollNextEvent.emit()"
    (scrollPreviousEvent)="scrollPreviousEvent.emit()">
    @for (item of items; track $index) {
        <sirius-image-item
            class="sir-thumbnail"
            [image]="thumbnails[$index]"
            [imageData]="getThumbnailImageData()"
            [autocrop]="true"
            tabindex="0"
            role="button"
            [attr.aria-label]="item.title || 'Open media item'"
            (click)="onClick($index)"
            (keydown.enter)="onClick($index)"
            (keydown.space)="$event.preventDefault(); onClick($index)"
            (mouseenter)="onMouseEnter($index)"
            (mouseleave)="onMouseLeave()"
            data-cy="media-item">
            @if (item.type === 'video') {
                <sirius-play-button [hovered]="hoveredIndex() === $index" [focusable]="false" data-cy="video-play-btn"></sirius-play-button>
            }
        </sirius-image-item>
    }
</sirius-slider>
